import { ErrorFilled } from '@carbon/react/icons';
import { AtomField } from 'atoms/form-atoms';
import { TextInput } from '@carbon/react';
import { useAtomValue, useSetAtom } from 'jotai';
import { ReactNode } from 'react';

import style from './text-field.module.scss';
import classNames from 'classnames';

export interface TextFieldProps {
  id: string;
  labelText: ReactNode;
  fieldAtom: AtomField<string | null> | AtomField<string>;
  autoComplete?: string;
  placeholder?: string;
  disabled?: boolean;
  light?: boolean;
}

export const TextField = ({
  id,
  labelText,
  fieldAtom,
  autoComplete,
  placeholder,
  disabled,
  light,
}: TextFieldProps) => {
  const setField = useSetAtom(fieldAtom);
  const field = useAtomValue(fieldAtom);
  return (
    <div className={classNames(style.field, { [style.light]: light })}>
      <TextInput
        id={id}
        labelText={
          <label>
            {labelText}
            {!field.isValid ? (
              <span className={style.required}>
                <ErrorFilled />
              </span>
            ) : (
              ''
            )}
          </label>
        }
        size="md"
        value={field.value || ''}
        onChange={({ target: { value } }) => setField(value)}
        invalid={!field.isValid && field.isDirty}
        invalidText={!field.isValid && field.isDirty ? field.error : ''}
        autoComplete={autoComplete}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  );
};
